var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"effect-list"},_vm._l((_vm.effects),function(effect){return _c('effect-item',{key:effect.id,attrs:{"effect":effect}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }